module.exports = __webpack_public_path__ + "static/media/login-image-marketPalace.f80caba6.png";